import { httpservice, Message } from 'src/app/commons/commons.module';
import { Component, inject, Inject, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginatorIntlCro } from 'src/app/commons/commons.module';
import { Router } from '@angular/router';
import { KarticaComponent } from '../../../../Komunalno/SaldaKonti/Kartica/kartica.component';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { PokretanjePodaci } from 'src/app/_models/Utuzivanje/pokretanjepodaci';
import { DialogComponent } from 'src/app/_dialog/dialog.component';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { formatDate } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LoginService } from 'src/app/login/login.service';
import { User } from 'src/app/_models/user';
import { KorisnikSelectComponent } from '../../../../Komunalno/Korisnik/korisnik-select.component';
import { KorisnikInfoComponent } from 'src/app/Komunalno/Korisnik/korisnik-info.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDatepickerIntl } from '@angular/material/datepicker';
import { Kartica } from './kartica';
import { Pokretanje } from './pokretanje';


@Component({
  selector: 'start-odabirom',
  templateUrl: './start-odabirom.component.html',
  styleUrls: ['./start-odabirom.component.css']  
  , animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0'})),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],  
})
export class StartOdabiromComponent implements OnInit {
  getservice: httpservice;
  displayedColumns: string[] = ['datum','isprava', 'opis', 'racun', 'datumRacuna','valutaRacuna','duguje','potrazuje', 'pokrenipostupak'];
  @ViewChild(MatSort) sort: MatSort;
  


  selectedrow: any;
  listadokumenata: any;
  qDokument: any;
  brojkorisnika: number;
  dugod: number;
  dugdo: number;
  lista: any;
  rezultat: any;
  loading: boolean;
  loadingstart: boolean;
  brojodabranih = 0;
  oznaci: boolean;
  startdata: PokretanjePodaci = { dokumentId: 0, nadan: new Date(), danduga: new Date(), korisnici: null, rokdana: 0, tipdana: false, tipiznosa: false, tipracuna: false, tipkartica: false, oddana: new Date(), dodana: new Date(),pamtiracune:false,vrstausluge:"",konto:"",saldo:"" };
  loginService: LoginService;
  login: User;
  korisnik: string;
  pojedinacnikorisnik: string;
  saldo: string;
  ukupnoduguje: number;
  ukupnopotrazuje: number;

  constructor(dataservice: httpservice, loginservice: LoginService, public dialog: MatDialog, private router: Router, @Inject(LOCALE_ID) private locale: string, private _snackBar: MatSnackBar) {
    this.getservice = dataservice;
    this.loginService = loginservice;

  }
  ngOnInit() {
    this.oznaci = true;
    this.startdata.nadan = new Date();
    this.loading = false;
    this.loadingstart = false;
    this.brojkorisnika = 0;
    this.qDokument = "";
    this.dugod = 0;
    this.dugdo = 0;
    this.korisnik = "";
    this.pojedinacnikorisnik = "0";
    this.saldo = "0";
    this.ukupnoduguje = 0;
    this.ukupnopotrazuje = 0;

    this.loginService.currentUser.subscribe(data => {
      this.login = data;
    });
    this.UcitajDokumente();
  }

  UcitajKarticu() {
    this.loadingstart = true;
    this.getservice.GetRequest<Message>("komunalno/saldakonti/kartica/KarticaKorisnikaZaOdabir?korisnik=" + this.korisnik).subscribe(result => {
      this.loadingstart = false;
      if (result.status === "success") {
        this.lista = new MatTableDataSource<Kartica>(Object.values(result.data));
        if (this.lista.data.length > 0) {
          this.lista.data.forEach(l => l.pokrenipostupak = true);
          this.selectedrow = this.lista.data[0];
          this.rezultat = null;
          setTimeout(() => this.lista.sort = this.sort, 2000);
          this.prebroj();          
        }
      }
    });
  }
  
  UcitajDokumente() {
    this.getservice.GetRequest<Message>("komunalno/saldakonti/dokumentvrsta/List").subscribe(result => {
      if (result.status === "success") {
        this.listadokumenata = Object.values(result.data);        
      }
    }, error => console.error('Get obveznike', error));
  }

  
  openDialog() {
    let broj: number = 0;
    this.lista.data.forEach((e, i) => {
      if (e.pokrenipostupak) {
        ++broj;
      }
    });
      const dialogRef = this.dialog.open(DialogComponent, {
        data: {
          pitanje: 'Da li ste sigurni ?',
          pojasnjenje: 'Pokretanje '+broj+' postupka'
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.PokreniPostupak();
        }
      });
    
  }


  PokreniPostupak() {
    if (this.startdata.dokumentId != 0) {
      let data = new Pokretanje();
      this.loading = true;
      data.korisnik = this.korisnik;
      data.rokdana = this.startdata.rokdana;
      data.dokumentId = this.startdata.dokumentId;
      data.nadan = this.startdata.nadan;
      
      console.log(data);
      this.lista.data.forEach((e:Kartica) => {
        if (e.pokrenipostupak) {
          data.saldaStavkaId.push(e.saldaStavkaId);
        }
      }
      );
      this.getservice.PostRequest<Message>("komunalno/saldakonti/utuzivanje/startpojedinacni", data).subscribe(result => {
        this.PostupakZavrsen(result.data, "Uredu");
        this.lista = null;
        this.loading = false;
      }, error => {
        this.rezultat = "Greška prilikom pokretanja postupka " + error;
        
      });
    }
  }

  prebroj() {
    this.brojodabranih = 0;
    this.ukupnoduguje = 0;
    this.ukupnopotrazuje = 0;
    this.lista.data.forEach((e, i) => {
      this.ukupnoduguje += e.duguje;
      this.ukupnopotrazuje += e.potrazuje;
      if (e.pokrenipostupak) {
        this.brojodabranih++;
        
      }
      
    }
    );
  }

  pocetniuvjeti() {
    this.lista = null;
  }

  PostupakZavrsen(message: string, action: string) {
    this._snackBar.open(message, action);
  }

  OznaciSve() {
    if (this.oznaci) {
      this.lista.data.forEach((e, i) => {
        e.pokrenipostupak = false;
      });
      this.oznaci = false;
    }
    else {
      this.lista.data.forEach((e, i) => {
        e.pokrenipostupak = true;
      });
      this.oznaci = true;
    }
    this.prebroj();
  }

  OdabirKorisnika(izbor: string) {
    this.korisnik = izbor;
    this.UcitajKarticu();
  }
 
  onchangeKorisnik(value) {
    if (this.pojedinacnikorisnik === "0") {
      this.korisnik = "";
    }
  }
}


